import { createAction } from "redux-actions";

export const getCountries = createAction("GET_COUNTRIES");
export const setCountries = createAction("SET_COUNTRIES");
